import React from 'react'
import { CurrencyText } from '../../../Global'

export const TableDataCellCosts = ({ dataValue }: { dataValue?: number }) => {
  return <CurrencyText value={Number(dataValue)} />
}
